import './theme/main.css';
import './theme/native-blocks.css';
import './blocks/Hero/style.css';
import './blocks/NewsGrid/style.css';
import './blocks/ProcessSearch/style.css';
import './blocks/ConsultationSearch/style.css';
import './blocks/SectionBanner/style.css';
import './blocks/Cards/style.css';
import './blocks/Accordion/style.css';
import './blocks/LinkList/style.css';
import './blocks/ProgramCards/style.css';
import './blocks/QuickLinks/style.css';
import './blocks/AnexosLista/style.css';
import './blocks/Galeria/style.css';
import './components/listing-ds.css';
import './components/busca/busca.css';
import './blocks/ImagemPrincipal/style.css';
import './blocks/Tabs/style.css';
import './blocks/Statistic/style.css';
import './blocks/Institutional/style.css';
import './blocks/Spacer/style.css';
import './blocks/CabecalhoSecao/style.css';
import './blocks/Button/style.css';
import './blocks/PageBanner/style.css';
import './blocks/AnchorNav/style.css';
import './blocks/ContatoFixo/style.css';
import './blocks/Destaque/style.css';
import './blocks/Passos/style.css';
import './blocks/Aviso/style.css';
import './blocks/Prazo/style.css';
import './blocks/Mapa/style.css';
import './blocks/Citacao/style.css';
import './blocks/Videos/style.css';
import './blocks/Glossario/style.css';
import './blocks/Pillars/style.css';
import './blocks/Timeline/style.css';
import './blocks/Team/style.css';
import './blocks/Organograma/style.css';
import './blocks/MostRead/style.css';
import './blocks/Teaser/style.css';
import './blocks/Search/style.css';
import './components/cookie.css';
import './components/news-view.css';
import './components/contract-view.css';
import './components/entity-view.css';
import './components/transparency.css';
import './components/specialized-care.css';

import HeroView from './blocks/Hero/View';
import HeroEdit from './blocks/Hero/Edit';
import NewsGridView from './blocks/NewsGrid/View';
import NewsGridEdit from './blocks/NewsGrid/Edit';
import getNewsGridAsyncData from './blocks/NewsGrid/getAsyncData';
import ProcessSearchView from './blocks/ProcessSearch/View';
import ProcessSearchEdit from './blocks/ProcessSearch/Edit';
import getProcessSearchAsyncData from './blocks/ProcessSearch/getAsyncData';
import ConsultationSearchView from './blocks/ConsultationSearch/View';
import ConsultationSearchEdit from './blocks/ConsultationSearch/Edit';
import getConsultationSearchAsyncData from './blocks/ConsultationSearch/getAsyncData';
import SectionBannerView from './blocks/SectionBanner/View';
import SectionBannerEdit from './blocks/SectionBanner/Edit';
import CardsView from './blocks/Cards/View';
import CardsEdit from './blocks/Cards/Edit';
import AccordionView from './blocks/Accordion/View';
import DestaqueView from './blocks/Destaque/View';
import DestaqueEdit from './blocks/Destaque/Edit';
import PassosView from './blocks/Passos/View';
import PassosEdit from './blocks/Passos/Edit';
import AvisoView from './blocks/Aviso/View';
import AvisoEdit from './blocks/Aviso/Edit';
import PrazoView from './blocks/Prazo/View';
import PrazoEdit from './blocks/Prazo/Edit';
import MapaView from './blocks/Mapa/View';
import MapaEdit from './blocks/Mapa/Edit';
import CitacaoView from './blocks/Citacao/View';
import CitacaoEdit from './blocks/Citacao/Edit';
import VideosView from './blocks/Videos/View';
import VideosEdit from './blocks/Videos/Edit';
import GlossarioView from './blocks/Glossario/View';
import GlossarioEdit from './blocks/Glossario/Edit';
import AccordionEdit from './blocks/Accordion/Edit';
import ContatoFixoView from './blocks/ContatoFixo/View';
import ContatoFixoEdit from './blocks/ContatoFixo/Edit';
import LinkListView from './blocks/LinkList/View';
import LinkListEdit from './blocks/LinkList/Edit';
import ProgramCardsView from './blocks/ProgramCards/View';
import ProgramCardsEdit from './blocks/ProgramCards/Edit';
import QuickLinksView from './blocks/QuickLinks/View';
import QuickLinksEdit from './blocks/QuickLinks/Edit';
import AnexosListaView from './blocks/AnexosLista/View';
import AnexosListaEdit from './blocks/AnexosLista/Edit';
import GaleriaView from './blocks/Galeria/View';
import GaleriaEdit from './blocks/Galeria/Edit';
import ImagemPrincipalView from './blocks/ImagemPrincipal/View';
import ImagemPrincipalEdit from './blocks/ImagemPrincipal/Edit';
import PageBannerView from './blocks/PageBanner/View';
import PageBannerEdit from './blocks/PageBanner/Edit';
import AnchorNavView from './blocks/AnchorNav/View';
import AnchorNavEdit from './blocks/AnchorNav/Edit';
import PillarsView from './blocks/Pillars/View';
import PillarsEdit from './blocks/Pillars/Edit';
import TimelineView from './blocks/Timeline/View';
import TimelineEdit from './blocks/Timeline/Edit';
import TeamView from './blocks/Team/View';
import TeamEdit from './blocks/Team/Edit';
import OrganogramaView from './blocks/Organograma/View';
import OrganogramaEdit from './blocks/Organograma/Edit';
import MostReadView from './blocks/MostRead/View';
import MostReadEdit from './blocks/MostRead/Edit';
import ButtonView from './blocks/Button/View';
import ButtonEdit from './blocks/Button/Edit';
import SpacerView from './blocks/Spacer/View';
import SpacerEdit from './blocks/Spacer/Edit';
import CabecalhoSecaoView from './blocks/CabecalhoSecao/View';
import CabecalhoSecaoEdit from './blocks/CabecalhoSecao/Edit';
import InstitutionalView from './blocks/Institutional/View';
import InstitutionalEdit from './blocks/Institutional/Edit';
import TabsView from './blocks/Tabs/View';
import TabsEdit from './blocks/Tabs/Edit';
import StatisticView from './blocks/Statistic/View';
import StatisticEdit from './blocks/Statistic/Edit';
import SearchView from './blocks/Search/View';
import SearchEdit from './blocks/Search/Edit';
import NoopBlockView from './blocks/Noop/View';
import LegacyLinksView from './blocks/LegacyLinks/View';
import NewsItemView from './components/NewsItemView';
import ContractView from './components/ContractView';
import EntityView from './components/EntityView';
import ImageFallback from './components/ImageFallback';
import Analytics from './components/Analytics';
import AgsusListaTemplate from './components/listing-variations/AgsusListaTemplate';
import AgsusListaLayout from './components/listing-variations/AgsusListaLayout';
import AnoTituloFacet, {
  AnoTituloFilterListEntry,
} from './components/listing-variations/AnoTituloFacet';
import AgsusFilteredListing from './components/listing-variations/AgsusFilteredListing';

import megaphoneSVG from '@plone/volto/icons/megaphone.svg';
import newsSVG from '@plone/volto/icons/news.svg';
import zoomSVG from '@plone/volto/icons/zoom.svg';
import bannerSVG from '@plone/volto/icons/image.svg';
import cardsSVG from '@plone/volto/icons/apps.svg';
import accordionSVG from '@plone/volto/icons/list-bullet.svg';
import contatoFixoSVG from '@plone/volto/icons/comment.svg';
import mapaSVG from '@plone/volto/icons/map.svg';
import citacaoSVG from '@plone/volto/icons/quote.svg';
import videosSVG from '@plone/volto/icons/videocamera.svg';
import glossarioSVG from '@plone/volto/icons/book.svg';
import destaqueSVG from '@plone/volto/icons/image-left.svg';
import passosSVG from '@plone/volto/icons/list-numbered.svg';
import avisoSVG from '@plone/volto/icons/info.svg';
import prazoSVG from '@plone/volto/icons/calendar.svg';
import linkListSVG from '@plone/volto/icons/link.svg';
import cabecalhoSecaoSVG from '@plone/volto/icons/heading.svg';
import programSVG from '@plone/volto/icons/grid.svg';
import pageBannerSVG from '@plone/volto/icons/heading.svg';
import anchorNavSVG from '@plone/volto/icons/navigation.svg';
import pillarsSVG from '@plone/volto/icons/list-numbered.svg';
import timelineSVG from '@plone/volto/icons/clock.svg';
import teamSVG from '@plone/volto/icons/add-user.svg';
import organogramaSVG from '@plone/volto/icons/apps.svg';
import buttonSVG from '@plone/volto/icons/circle-bottom.svg';
import spacerSVG from '@plone/volto/icons/move.svg';
import institutionalSVG from '@plone/volto/icons/news.svg';
import quickSVG from '@plone/volto/icons/external-link.svg';
import anexosSVG from '@plone/volto/icons/attachment.svg';
import galeriaSVG from '@plone/volto/icons/images.svg';
import imagemSVG from '@plone/volto/icons/image.svg';
import tabsSVG from '@plone/volto/icons/tab.svg';
import statSVG from '@plone/volto/icons/state.svg';
import searchSVG from '@plone/volto/icons/zoom.svg';
import { rodapeAsyncPropExtender } from './components/footer/rodape';
import DataDoEventoWidget from './components/DataDoEvento/DataDoEventoWidget';
import { comLinksSemEnderecoInterno } from './components/linksInternos/linksInternos';
import { comVirtualHost } from './components/linksInternos/virtualHost';

const applyConfig = (config) => {
  config.settings.matomoSiteId = undefined;
  // Estatística de uso: a mesma tag do Google do site anterior (histórico contínuo na mesma propriedade).
  // Só carrega no endereço oficial e com o consentimento "Estatística" (components/Analytics.jsx).
  config.settings.googleTagId = 'GT-PZMTCC8F';
  config.settings.googleTagHosts = [
    'www.agenciasus.org.br',
    'agenciasus.org.br',
  ];
  config.settings.showSelfRegistration = false;
  // Idioma da interface do Volto (edição, mensagens, páginas de erro). O padrão
  // do core é supportedLanguages ['en'], e o servidor só carrega a tradução dos
  // idiomas dessa lista: com o conteúdo em pt-BR, a interface saía em inglês.
  // A tradução (locales/pt_BR.json do core) é gerada a cada build.
  config.settings.supportedLanguages = ['pt-br'];
  config.settings.defaultLanguage = 'pt-br';
  config.settings.appExtras = [
    ...(config.settings.appExtras || []),
    {
      match: { path: '' },
      component: ImageFallback,
    },
    {
      match: { path: '' },
      component: Analytics,
    },
  ];
  // colunas do rodapé editável (/configuracao/footer) já na renderização do servidor
  config.settings.asyncPropsExtenders = [
    ...(config.settings.asyncPropsExtenders || []),
    rodapeAsyncPropExtender,
  ];

  config.blocks.blocksConfig.agsusHero = {
    id: 'agsusHero',
    title: 'AgSUS Hero',
    icon: megaphoneSVG,
    group: 'common',
    view: HeroView,
    edit: HeroEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusProcessSearch = {
    id: 'agsusProcessSearch',
    title: 'AgSUS Process Search',
    icon: zoomSVG,
    group: 'common',
    view: ProcessSearchView,
    edit: ProcessSearchEdit,
    getAsyncData: getProcessSearchAsyncData,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusConsultationSearch = {
    id: 'agsusConsultationSearch',
    title: 'AgSUS Consultation Search',
    icon: zoomSVG,
    group: 'common',
    view: ConsultationSearchView,
    edit: ConsultationSearchEdit,
    getAsyncData: getConsultationSearchAsyncData,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusNewsGrid = {
    id: 'agsusNewsGrid',
    title: 'AgSUS News Grid',
    icon: newsSVG,
    group: 'common',
    view: NewsGridView,
    edit: NewsGridEdit,
    getAsyncData: getNewsGridAsyncData,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusSectionBanner = {
    id: 'agsusSectionBanner',
    title: 'AgSUS Section Banner',
    icon: bannerSVG,
    group: 'common',
    view: SectionBannerView,
    edit: SectionBannerEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusCards = {
    id: 'agsusCards',
    title: 'AgSUS Cards (acesso)',
    icon: cardsSVG,
    group: 'common',
    view: CardsView,
    edit: CardsEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusAccordion = {
    id: 'agsusAccordion',
    title: 'AgSUS Accordion',
    icon: accordionSVG,
    group: 'common',
    view: AccordionView,
    edit: AccordionEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    // O Edit tem campos e um BlocksForm aninhado. Sem esta flag o Volto
    // prende o teclado no invólucro do bloco: Enter no campo da pergunta
    // criava um parágrafo vazio depois do acordeão e tirava a seleção dele
    // (e o invólucro roubava o foco a cada seleção). Mesmo padrão do
    // @eeacms/volto-accordion-block.
    blockHasOwnFocusManagement: true,
  };

  // Destaque: o módulo dos folders (cartão com foto e etiqueta, foto ao lado,
  // painel de cor). Tem campos e um BlocksForm aninhado, como a sanfona.
  config.blocks.blocksConfig.agsusDestaque = {
    id: 'agsusDestaque',
    title: 'AgSUS Destaque',
    icon: destaqueSVG,
    group: 'common',
    view: DestaqueView,
    edit: DestaqueEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    blockHasOwnFocusManagement: true,
  };

  // Passo a passo: etapas numeradas nas cores da faixa da marca.
  config.blocks.blocksConfig.agsusPassos = {
    id: 'agsusPassos',
    title: 'AgSUS Passo a passo',
    icon: passosSVG,
    group: 'common',
    view: PassosView,
    edit: PassosEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  // Aviso: caixa de atenção, prazo, importante ou nota; texto aninhado, como
  // no Destaque.
  config.blocks.blocksConfig.agsusAviso = {
    id: 'agsusAviso',
    title: 'AgSUS Aviso',
    icon: avisoSVG,
    group: 'common',
    view: AvisoView,
    edit: AvisoEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    blockHasOwnFocusManagement: true,
  };

  // Prazo de edital: datas que mudam de situação sozinhas e cronograma colado
  // do PDF (o painel tem campo de texto: Enter não pode sair do bloco).
  config.blocks.blocksConfig.agsusPrazo = {
    id: 'agsusPrazo',
    title: 'AgSUS Prazo de edital',
    icon: prazoSVG,
    group: 'common',
    view: PrazoView,
    edit: PrazoEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    blockHasOwnFocusManagement: true,
  };

  // Mapa do Brasil: pontos em cidades ou um número por estado (o painel
  // "Colar a lista de pontos" tem campo de texto: Enter não pode sair do bloco).
  config.blocks.blocksConfig.agsusMapa = {
    id: 'agsusMapa',
    title: 'AgSUS Mapa do Brasil',
    icon: mapaSVG,
    group: 'common',
    view: MapaView,
    edit: MapaEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    blockHasOwnFocusManagement: true,
  };

  // Citação ou depoimento: painel azul ou cartão com barra de cor.
  config.blocks.blocksConfig.agsusCitacao = {
    id: 'agsusCitacao',
    title: 'AgSUS Citação',
    icon: citacaoSVG,
    group: 'common',
    view: CitacaoView,
    edit: CitacaoEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  // Lista de vídeos do YouTube: player que só carrega no clique (nocookie).
  config.blocks.blocksConfig.agsusVideos = {
    id: 'agsusVideos',
    title: 'AgSUS Lista de vídeos',
    icon: videosSVG,
    group: 'media',
    view: VideosView,
    edit: VideosEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Glossário de siglas: completo (busca e letras) ou recolhível, no fim da página.
  config.blocks.blocksConfig.agsusGlossario = {
    id: 'agsusGlossario',
    title: 'AgSUS Glossário de siglas',
    icon: glossarioSVG,
    group: 'common',
    view: GlossarioView,
    edit: GlossarioEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusContatoFixo = {
    id: 'agsusContatoFixo',
    title: 'AgSUS Contato fixo',
    icon: contatoFixoSVG,
    group: 'common',
    view: ContatoFixoView,
    edit: ContatoFixoEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusLinkList = {
    id: 'agsusLinkList',
    title: 'AgSUS Link List',
    icon: linkListSVG,
    group: 'common',
    view: LinkListView,
    edit: LinkListEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusProgramCards = {
    id: 'agsusProgramCards',
    title: 'AgSUS Program Cards',
    icon: programSVG,
    group: 'common',
    view: ProgramCardsView,
    edit: ProgramCardsEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusQuickLinks = {
    id: 'agsusQuickLinks',
    title: 'AgSUS Quick Links',
    icon: quickSVG,
    group: 'common',
    view: QuickLinksView,
    edit: QuickLinksEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusPageBanner = {
    id: 'agsusPageBanner',
    title: 'Banner de Página',
    icon: pageBannerSVG,
    group: 'common',
    view: PageBannerView,
    edit: PageBannerEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusAnchorNav = {
    id: 'agsusAnchorNav',
    title: 'AgSUS Anchor Nav',
    icon: anchorNavSVG,
    group: 'common',
    view: AnchorNavView,
    edit: AnchorNavEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusPillars = {
    id: 'agsusPillars',
    title: 'AgSUS Pilares',
    icon: pillarsSVG,
    group: 'common',
    view: PillarsView,
    edit: PillarsEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusTimeline = {
    id: 'agsusTimeline',
    title: 'AgSUS Linha do Tempo',
    icon: timelineSVG,
    group: 'common',
    view: TimelineView,
    edit: TimelineEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusTeam = {
    id: 'agsusTeam',
    title: 'AgSUS Equipe',
    icon: teamSVG,
    group: 'common',
    view: TeamView,
    edit: TeamEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusOrganograma = {
    id: 'agsusOrganograma',
    title: 'AgSUS Organograma',
    icon: organogramaSVG,
    group: 'common',
    view: OrganogramaView,
    edit: OrganogramaEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusMostRead = {
    id: 'agsusMostRead',
    icon: newsSVG,
    title: 'AgSUS Mais Vistas',
    group: 'common',
    view: MostReadView,
    edit: MostReadEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusButton = {
    id: 'agsusButton',
    title: 'Botão',
    icon: buttonSVG,
    group: 'common',
    view: ButtonView,
    edit: ButtonEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  // Compatibilidade com o bloco de botao legado ja salvo no Plone. O View
  // normaliza os campos antigos (title, href relacional e inneralign), sem
  // migracao de conteudo e sem exibir "Unknown Block".
  config.blocks.blocksConfig.__button = {
    ...config.blocks.blocksConfig.agsusButton,
    id: '__button',
    title: 'Botão AgSUS (legado)',
    restricted: true,
    mostUsed: false,
  };

  config.blocks.blocksConfig.agsusSpacer = {
    id: 'agsusSpacer',
    title: 'Espaçador',
    icon: spacerSVG,
    group: 'common',
    view: SpacerView,
    edit: SpacerEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Marcador entre seções: só o cabeçalho (selo, título e link opcional à
  // direita), no desenho do cabeçalho da grade de notícias (22/10/2026).
  config.blocks.blocksConfig.agsusCabecalhoSecao = {
    id: 'agsusCabecalhoSecao',
    title: 'Cabeçalho de seção',
    icon: cabecalhoSecaoSVG,
    group: 'common',
    view: CabecalhoSecaoView,
    edit: CabecalhoSecaoEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.agsusInstitutional = {
    id: 'agsusInstitutional',
    title: 'AgSUS Institucional',
    icon: institutionalSVG,
    group: 'common',
    view: InstitutionalView,
    edit: InstitutionalEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  // AnexosLista — lista anexos (File/Image filhos do contexto)
  const anexosConfig = {
    id: 'agsusAnexosLista',
    title: 'Anexos (lista)',
    icon: anexosSVG,
    group: 'common',
    view: AnexosListaView,
    edit: AnexosListaEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };
  config.blocks.blocksConfig.agsusAnexosLista = anexosConfig;
  config.blocks.blocksConfig['anexos-lista'] = {
    ...anexosConfig,
    id: 'anexos-lista',
    title: 'Anexos (legado AgSUS)',
    restricted: true,
  };

  // Galeria de fotos — as imagens dentro da própria página, na ordem da tela
  // Conteúdo; grade leve em lotes de 12 e foto ampliada em <dialog>.
  // Mesmo código no portal e na intranet (blocks/Galeria).
  config.blocks.blocksConfig.agsusGaleria = {
    id: 'agsusGaleria',
    title: 'Galeria de fotos',
    icon: galeriaSVG,
    group: 'common',
    view: GaleriaView,
    edit: GaleriaEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Imagem Principal — bloco integrado a preview_image_link/preview_caption_link
  config.blocks.blocksConfig.agsusImagemPrincipal = {
    id: 'agsusImagemPrincipal',
    title: 'Imagem Principal',
    icon: imagemSVG,
    group: 'common',
    view: ImagemPrincipalView,
    edit: ImagemPrincipalEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  // Legacy @types do Plone AgSUS (featured-image, newsitem-meta, eyebrow):
  // já filtramos visualmente em NewsItemView via HIDDEN_TYPES, mas o
  // Volto Form (Form.jsx:554) acessa config.blocks.blocksConfig[type]
  // .blockSchema direto, e quebra com TypeError se o type não estiver
  // registrado. Registrar como no-op (View=null, Edit=null) deixa o
  // form salvar sem quebrar.
  const noopConfig = {
    icon: imagemSVG,
    group: 'common',
    view: NoopBlockView,
    edit: NoopBlockView,
    restricted: true,
    mostUsed: false,
    sidebarTab: 0,
  };
  config.blocks.blocksConfig.__links = {
    id: '__links',
    title: 'Lista de links (legado AgSUS)',
    icon: linkListSVG,
    group: 'common',
    view: LegacyLinksView,
    edit: LegacyLinksView,
    restricted: true,
    mostUsed: false,
    sidebarTab: 0,
  };
  config.blocks.blocksConfig['featured-image'] = {
    ...noopConfig,
    id: 'featured-image',
    title: 'Featured Image (legado AgSUS — invisível)',
  };
  config.blocks.blocksConfig['newsitem-meta'] = {
    ...noopConfig,
    id: 'newsitem-meta',
    title: 'News Item Meta (legado AgSUS — invisível)',
  };
  config.blocks.blocksConfig['eyebrow'] = {
    ...noopConfig,
    id: 'eyebrow',
    title: 'Eyebrow (legado AgSUS — invisível)',
  };

  // Template inicial para criar nova Notícia (News Item):
  // título + descrição + Imagem Principal + parágrafo vazio.
  // Quando o editor clicar em Adicionar → Notícia, o esqueleto já vem
  // pronto. Volto core (Add.jsx) lê config.blocks.initialBlocks[type].
  config.blocks.initialBlocks['News Item'] = [
    { '@type': 'title' },
    { '@type': 'description' },
    { '@type': 'agsusImagemPrincipal' },
    {
      '@type': 'slate',
      value: [{ type: 'p', children: [{ text: '' }] }],
      plaintext: '',
    },
  ];

  // Cotação de Preços nasce montada: título, prazo das propostas e a lista dos documentos que ficam dentro
  // dela. Valores do prazo = os das cotações publicadas (rótulo "Propostas", das 00:00 às 23:59).
  config.blocks.initialBlocks.Cotacao = [
    { '@type': 'title' },
    {
      '@type': 'agsusPrazo',
      rotulo: 'Propostas',
      horaInicio: '00:00',
      horaFim: '23:59',
      textoBotao: 'Ver a requisição de proposta',
    },
    { '@type': 'agsusAnexosLista' },
  ];

  // Processo Seletivo nasce montado: título, prazo das inscrições (com o cronograma colado depois) e a lista
  // dos documentos que ficam dentro dele (edital, anexos, resultados, retificações).
  config.blocks.initialBlocks.ProcessoSeletivo = [
    { '@type': 'title' },
    { '@type': 'agsusPrazo', rotulo: 'Inscrições', textoBotao: 'Ver o edital' },
    { '@type': 'agsusAnexosLista' },
  ];

  // Tabs — abas com sub-blocks Volto, compat com tabs_block legado
  config.blocks.blocksConfig.agsusTabs = {
    id: 'agsusTabs',
    title: 'AgSUS Tabs',
    icon: tabsSVG,
    group: 'common',
    view: TabsView,
    edit: TabsEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Estatísticas — KPI/cards numéricos
  config.blocks.blocksConfig.agsusStatistic = {
    id: 'agsusStatistic',
    title: 'Estatísticas',
    icon: statSVG,
    group: 'common',
    view: StatisticView,
    edit: StatisticEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  // Busca — campo que submete para /search
  config.blocks.blocksConfig.agsusSearch = {
    id: 'agsusSearch',
    title: 'AgSUS Busca',
    icon: searchSVG,
    group: 'common',
    view: SearchView,
    edit: SearchEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  // Override views — News Item nativo + 6 CTs custom
  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    'News Item': NewsItemView,
    // Cotação de Preços (tipo próprio desde 11/2026): registro documental, como as cotações migradas
    Cotacao: ContractView,
    // Processo Seletivo (tipo próprio desde 11/2026): registro documental, como os editais migrados
    ProcessoSeletivo: ContractView,
    Edital: EntityView,
    Audiencia: EntityView,
  };

  // Layout 'contract_view' — render simplificado para cotações/contratações/
  // credenciamentos/audiências (News Item com layout trocado). Tem precedência
  // sobre contentTypesViews['News Item'] (Volto: getViewByLayout || getViewByType).
  config.views.layoutViews = {
    ...config.views.layoutViews,
    contract_view: ContractView,
  };

  // Desabilita slot 'tags' do belowContent — nós renderizamos as tags
  // dentro do NewsItemView, no rodapé do __inner. Sem isso, o Volto core
  // injeta um <div class="ui container tags"> redundante depois do article.
  //
  // Estrutura do slot no registry novo (volto 18):
  //   config.slots[name] = { slots: ['tags', 'relatedItems'], data: {...} }
  const below = config.slots?.belowContent;
  if (below && Array.isArray(below.slots)) {
    below.slots = below.slots.filter((s) => s !== 'tags');
    if (below.data) {
      delete below.data.tags;
    }
  }

  // Search variation DS (card: faixa azul clara + campo de busca + resultados).
  config.blocks.blocksConfig.search.variations = [
    ...config.blocks.blocksConfig.search.variations,
    {
      id: 'agsusLista',
      title: 'Lista DS (faixa + busca)',
      view: AgsusListaLayout,
    },
  ];

  // Variation DS de listagem (faixa azul clara + links de texto) para o Search
  // block das listas de transparencia (contratos, editais, credenciamentos...).
  config.blocks.blocksConfig.listing.variations = [
    ...config.blocks.blocksConfig.listing.variations.map((variation) =>
      variation.id === 'default'
        ? { ...variation, template: AgsusFilteredListing }
        : variation,
    ),
    {
      id: 'agsusListaDS',
      title: 'Lista DS (faixa azul clara)',
      template: AgsusListaTemplate,
    },
  ];

  // Facet de Subject em /processos-seletivos. O facet de status mostra sempre
  // os 3 status fixos (Aberto/Encerrado/Cancelado, labels curtos), independente
  // do que a query base recorta — assim a lista pode abrir pré-filtrada num
  // status (Subject na query base) mantendo os 3 chips visíveis pra troca.
  // Aplica só ao campo Subject; outros facets passam inalterados.
  const PS_STATUS_FACET = [
    // 19/08/2026: "Aberto" virou "em Andamento" (vocabulário oficial); as
    // tags do conteúdo foram migradas junto com este deploy.
    { value: 'Processo Seletivo em Andamento', label: 'Em andamento' },
    { value: 'Processo Seletivo Encerrado', label: 'Encerrado' },
    { value: 'Processo Seletivo Cancelado', label: 'Cancelado' },
  ];
  // Filtro de ano pelo título (Lista DS das contratações): botões de ano que
  // buscam o ano dentro do título, sem etiqueta nem data nos documentos.
  config.blocks.blocksConfig.search.extensions.facetWidgets.types.push({
    id: 'agsusAnoTitulo',
    title: 'Ano (pelo título)',
    view: AnoTituloFacet,
    isDefault: false,
    schemaEnhancer: AnoTituloFacet.schemaEnhancer,
    stateToValue: AnoTituloFacet.stateToValue,
    valueToQuery: AnoTituloFacet.valueToQuery,
    showFacet: AnoTituloFacet.showFacet,
    filterListComponent: AnoTituloFilterListEntry,
  });

  config.blocks.blocksConfig.search.extensions.facetWidgets.rewriteOptions = (
    name,
    options,
  ) => (name === 'Subject' ? PS_STATUS_FACET : options);

  // Bloco de imagem: o atributo sizes diz ao navegador que fração da tela a
  // imagem ocupa, e é por ele que se escolhe a escala baixada. Tem de bater
  // com a escala da AgSUS em theme/volto-overrides.css — G a coluna inteira,
  // M metade, P um terço, em qualquer alinhamento — e com o celular, onde M
  // e P alinhadas ocupam a coluna inteira (a centralizada mantém a proporção).
  // Com os valores do Volto (25vw para M alinhada), a foto saía numa escala
  // pequena e esticada.
  const PROPORCAO = { m: 50, s: 33 };
  const getSizesDoVolto = config.blocks.blocksConfig.image.getSizes;
  config.blocks.blocksConfig.image.getSizes = (data) => {
    const alinhada = data.align === 'left' || data.align === 'right';
    const vw = PROPORCAO[data.size];
    if (vw && alinhada) return `(max-width: 640px) 100vw, ${vw}vw`;
    if (vw && data.align === 'center') return `${vw}vw`;
    if (alinhada) return '100vw'; // G (ou sem tamanho): coluna inteira
    return getSizesDoVolto(data);
  };

  // Início e fim de evento de dia inteiro no horário de Brasília: sem isto,
  // o Plone grava a meia-noite UTC e o evento aparece um dia antes.
  config.widgets.id.start = DataDoEventoWidget;
  config.widgets.id.end = DataDoEventoWidget;

  // Endereço interno do Plone (127.0.0.1:8080) nunca vai para o conteúdo: vira o
  // caminho do site na gravação e nos blocos que chegam (ver linksInternos.js).
  config.settings.storeExtenders = [
    ...(config.settings.storeExtenders || []),
    comLinksSemEnderecoInterno,
  ];

  // E na origem: no servidor, o Plone devolve o endereço público em vez do
  // interno (VirtualHostMonster derivado do RAZZLE_API_PATH; ver virtualHost.js).
  if (__SERVER__) {
    config.settings.internalApiPath = comVirtualHost(
      config.settings.internalApiPath,
      config.settings.apiPath,
    );
  }

  return config;
};

export default applyConfig;
